import * as fromCandidate from '../actions/candidate.action';
import {Candidate} from '../../candidate';


export interface CandidateState {
  entities: Candidate[];
  entity?: Candidate;
  loading: boolean;
  loaded: boolean;
  error: string;
}

export const initialState = {
  entities: null,
  entity: null,
  loading: false,
  loaded: true,
  error: null,
};

export function reducer(state = initialState, action: fromCandidate.CandidateAction): CandidateState {
  switch (action.type) {
    case fromCandidate.GET_ALL_CANDIDATES: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromCandidate.GET_ALL_CANDIDATES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: action.payload,
        error: null
      };
    }
    case fromCandidate.GET_ALL_CANDIDATES_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: null,
        entity: null,
        error: action.payload
      };
    }
    case fromCandidate.GET_CANDIDATE: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromCandidate.GET_CANDIDATE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entity: action.payload,
        error: null
      };
    }
    case fromCandidate.GET_CANDIDATE_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: null,
        entity: null,
        error: action.payload
      };
    }
    case fromCandidate.DELETE_CANDIDATE: {
      return state;
    }
    case fromCandidate.DELETE_CANDIDATE_SUCCESS: {
      return {
        ...state,
        entity: null,
        error: null,
      };
    }
    case fromCandidate.DELETE_CANDIDATE_ERROR: {
      return {
        ...state,
        error: action.payload
      };
    }
  }
  return state;
}




// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/candidates/store/reducers/candidate.reducer.ts